<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý model sản phẩm</div>
      </div>
      <div class="p-grid box_config_model">
        <div class="p-col-6 card card-w-title box_import_data" v-if="checkVisible('product', 'import')">
          <div class="" >
            <!-- <div class="card card-w-title"> -->
            <div class="box-title">Import model sản phẩm</div>
            <div class="import-data">

              <div class="box-form-import">
                <!-- <InputText readonly="true" id="filename" type="text" v-model="filename" /> -->
                <Button :disabled="files.length > 0" :label="'Chọn file'" @click="openFile"
                        :class="(files.length > 0 ? ' disabled ' : '') + 'item-inline-import'"/>
                <input id="files" ref="files" type="file" style="display:none" @change="chooseFile"/>
                <div :class="'item-inline-import middle-inline' + (files.length > 0 ? '' : ' normal')">
                  <label :class="files.length > 0 ? '' : 'normal'">{{ filename }}</label>
                  <a @click="removeFile" v-if="files.length > 0">Xoá</a>
                </div>
                <Button :disabled="files.length == 0 || submitForm"
                        :class="(files.length > 0 ? '' : 'background-none') + ' disabled-opacity item-inline-import'"
                        :label="'Import'" @click="importData"/>
              </div>
              <div class="download-file">
                <span class="class-span">Tải mẫu file import</span> <a @click="downloadFile">Tại đây <i class="pi pi-download"></i></a>
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-6 card card-w-title box_config_time" v-if="checkVisible('product', 'warranty_extension')" >
          <div class="" >
            <!-- <div class="card card-w-title"> -->
            <div class="box-title">Số ngày gia hạn thời gian bảo hành tối đa</div>
            <div class="import-data">

              <div class="box-form-import">
                <!-- <InputText readonly="true" id="filename" type="text" v-model="filename" /> -->
                <div class="group_input_date">
                  <InputNumber v-model="maximum_warranty_extension_time" :min="-1" :max="10000" @keyup="chang_date_number" class="input_date_number" type="text" mode="decimal" locale="de-DE" :minFractionDigits="0"  />
                  Ngày
                </div>
                <Button :disabled="disable_update_date_number"
                        :class="(disable_update_date_number == false ? '' : 'background-none') + ' disabled-opacity item-inline-import'"
                        :label="'Cập nhật'"  @click="update_date_number"/>
              </div>
              <p><span class="note_date_nunber">* Lưu ý</span>: Áp dụng cho tất cả model bên dưới</p>

            </div>
          </div>
        </div>
      </div>
      <div class="card card-w-title">
        <div class="list-data">
          <div class="p-grid" v-if="checkVisible('product', 'download')">
            <div class="p-col-6"  >
              <div class="import-data-custom download-data-custom">
                <button class="download-file-custom" @click="exportDataExcelFile" >
                  <i class="pi pi-download"></i>Xuất dữ liệu
                </button>
                <span >(Danh sách  model sản phẩm được tải về theo điều kiện lọc đã nhập)</span>
              </div>
            </div>
          </div>
          <div class="list-title">
            <span class="p-m-0">Danh sách model sản phẩm</span>
            <span class="p-input-icon-left" v-if="checkVisible('product', 'add')">
            <!-- <span class="p-input-icon-left"> -->
              <Button
              :label="'Tạo mới'"
                type="button"
                v-on:click="onActionClicked({action: {name: 'add', label: 'Tạo mới', path: `admin/product/add`}, key: 'add'})"
              > </Button>
            </span>
          </div>
          <BaseCommon v-if="dataModel"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            @filter="filterData"
            :actions="getRowActions()"
            :globalFilterFields="globalFilterFields"
            :columnsDisplays="columnsDisplays"
            :first="first"
            v-on:action-click="onActionClicked"
            v-on:page-click="pageClick"
            @callback="callback"
            @clearFilter="cancelFilter"
            @filterExport="filterExport"
          ></BaseCommon><!--:totalRecords="totalRecords"-->
        </div>
      </div>
    </div>
    <PopupMessage :key="importComponentKey" @export-excel="exportDataExcel"  :messages="messages" :displayDialog="displayDialog" @accept="acceptImport" @cancel="cancelImport"/>
    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
    >
      <div class="box_body_popup" >
        <div v-if="creenConfirmDialog == 'export_success'">
          <div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
          <p class="p_title_1" style="text-align: left"><span style="font-weight: 700">Danh sách model sản phẩm</span> đã xuất dữ liệu thành công. Vui lòng thực hiện tải về tại module Lịch sử xuất dữ liệu.</p>
          <div class="box_btn">
            <Button
                icon="pi pi-chevron-circle-right"
                iconPos="right"
                class="btn-custom"
                :label="'Lịch sử xuất dữ liệu'"
                type="button"
                @click="redirect_ToHistory"
            > </Button>
          </div>
        </div>
        <div v-if="creenConfirmDialog == 'export_err'">
          <div class="box_title_err"><img class="img_noti" :src="err_massage_img" /><span class="title_noti" style="">Thất bại</span></div>
          <p class="p_title_1" style="text-align: left">Quá trình xuất dữ liệu <span style="font-weight: 700;">Danh sách model sản phẩm</span> đã xảy ra vấn đề. Bạn vui lòng thực hiện lại thao tác xuất dữ liệu.</p>
        </div>
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Thông báo</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import axios from 'axios'
import DataServices from '@/core/DataServices'
//import BaseCommon from '../common'
import BaseCommon from './core_list';
import moment from 'moment'
import PopupMessage from '../common/popupMessage'
import Api from '@/services'
import XLSX from 'xlsx'
export default {
  components: {
    BaseCommon,
    PopupMessage
  },
  data() {
    return {
      urlFile: window.location.origin + '/upload/files/Template_import_model_sp.xlsx',
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      filename: 'Không có file đang chọn',
      optionsStatus: [],
      optionsCategories: [],
      name: '',
      code: '',
      categories_value: 0,
      status_value: 0,
      files: [],
      globalFilterFields: [],
      fileInputData: '',
      parse_header: [],
      parse_key: ["STT", "Model sản phẩm*", "Tên sản phẩm*", "Nhóm sản phẩm*", "Thời hạn bảo hành (tháng)*", "Thời hạn đổi (ngày)", "Thời hạn trả_tự duyệt (ngày)", "Thời hạn trả_thẩm định (ngày)", "Mẫu QR Code", "Trạng thái sản xuất*", "Hình ảnh"],
      importsErrors: [],
      errorsText: '',
      importCategories: [],
      seconds: 7,
      importID: 0,
      displayDialog: false,
      importComponentKey: 0,
      messages: {},
      exportData: [],
      columnsDisplays: [],
      submitForm: false,
      //totalRecords: 0,
      currentPage: 1,
      first: 3,
      disable_update_date_number:true,
      maximum_warranty_extension_time:0,
      listDataExport:[],
      creenConfirmDialog:'export_success',
      check_success_img: window.origin + '/assets/images/check_success.png',
      err_massage_img: window.origin + '/assets/images/err_massage.png',
      showConfirmDialog:false,
      userID : null,
      data_filter_export:null
    }
  },
  mounted () {
    this.initData();
    if(this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null){
      if(this.$store.getters.fullname.id !== undefined && this.$store.getters.fullname.id !== null && this.$store.getters.fullname.id !== ''){
        this.userID = this.$store.getters.fullname.id
      }
    }
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    initData() {
      setTimeout(async () => {
        if (!this.checkVisible('product', 'history')) {
          this.columnsDisplays.push('history')
        }
        if (!this.checkVisible('serial_number', 'list')) {
          this.columnsDisplays.push('serial_number')
        }
        if (this.checkVisible('product', 'list')) {
          await this.initParams();
          await this.getSettings();
        }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    callback(col, payload) {
      if (col.name == 'serial_number') {
        if (this.checkVisible('serial_number', 'list')) {
          this.$router.push({name: 'serial_number', params: {model: payload.model_code}});
        }  else {
          this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Bạn không có quyền truy cập', life: 3000 })
        }
      }
      else if(col.key == 'history') {
        if (this.checkVisible('product', 'history')) {
          this.$router.push({path: '/admin/product/history/' + payload.id});
        } else {
          this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Bạn không có quyền truy cập', life: 3000 })
        }
      }
    },
    downloadFile() {
      var filename = this.$myConstants.getFileName(this.urlFile);
      axios({
        url: this.urlFile,
        method: 'GET',
        responseType: 'blob',
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename);
          document.body.appendChild(fileLink);
          fileLink.click();
      });
    },
    async acceptImport() {
      this.submitForm = true;
      var params = {};
      params = Object.assign(params, { 'status': 5 });
      params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() });
      var result = await DataServices.updateData('import_data_processing', {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.importID }}})});
      if (result != null) {
        var checkUpdate = result[Object.keys(result)];
        if (checkUpdate.affected_rows) this.displayDialog = false;
      } else this.displayDialog = false;
      this.importComponentKey = Math.random()*380;
      this.$store.commit('setDataLoading', {content: 'Đang import dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.waittingImport();
    },
    async cancelImport() {
      var params = {};
      params = Object.assign(params, { 'status': 6 });
      params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() });
      var result = await DataServices.updateData('import_data_processing', {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.importID }}})});
      if (result != null) {
        var checkUpdate = result[Object.keys(result)];
        if (checkUpdate.affected_rows) this.displayDialog = false;
      } else this.displayDialog = false;
      this.importComponentKey = Math.random()*350;
      this.files = [];
      this.filename = 'Không có file đang chọn';
      document.getElementById('files').value = null;
      this.submitForm = false;
    },
    async getSettings() {
      var variables = {
        where_key: {
          key: {'_in': ['TIME_PROCESSING_IMPORT_SECONDS'] }
        }
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), 'fields' : 'value'});
      if (data != undefined && data != null) {
        var list = data[Object.keys(data)];
        if (Object.keys(list).length > 0) {
          this.seconds = parseInt(list[0].value);
        }
      }
    },
    async initParams() {
      var vm = this;
      //this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      //this.$store.commit('setLoading', true);
      this.limitPage = parseInt(localStorage.getItem('PAGINATION_ROWS'));
      this.offsetPage = ( this.currentPage - 1) * this.limitPage;
      this.modelName = 'product';
      /*var variables = {
        where_key: {
          status: {'_in': [1] },
          production_status: {'_in': [0, 1] },
          categories: {
            status: {'_eq': 1}
          }
        },
        orderBy: {
          id: 'desc',
          created_date: 'desc',
          modified_date: 'desc'
        }
      }
      var dataTotals = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "aggregate": "{ aggregate { count } }"});
      dataTotals = dataTotals[Object.keys(dataTotals)];
      if (dataTotals && Object.keys(dataTotals).length) {
        this.totalRecords = dataTotals.aggregate.count;
      }*/
      //this.totalRecords = 0;
      //var variablesLimit = variables;
      // variablesLimit = Object.assign(variablesLimit, {offset: this.offsetPage});
      /*// variablesLimit = Object.assign(variablesLimit, {limit: this.limitPage});
      var dataLimit = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variablesLimit)});
      var listLimit = dataLimit[Object.keys(dataLimit)];*/
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData([]);
      this.listDataExport = [];
      this.listData = [];
      this.componentKey = Math.random() * 2034;
      await this.categories();
      //Lấy cấu hình số ngày gia hạn bảo hành tối đá
      var whereObjectSetting = {
        key: {'_eq': this.$dataCommon.SETTING.MAXIMUM_WARRANTY_EXTENSION_TIME}
      }
      DataServices.getObjectData('settings', whereObjectSetting, {id: 'desc'}).then(async (resObj) => {
        if (resObj) {
          vm.maximum_warranty_extension_time = (!vm.$myConstants.isEmpty(resObj.value)) ? parseFloat(resObj.value):0
        }
      }).catch(async () => {});
      //this.$store.commit('setLoading', false);
    },
    async categories() {
      var variables = {
        where_key: {
          status: {'_in': [0,1] }
        },
        orderBy: {
          modified_date: 'desc_nulls_last',
          created_date: 'desc_nulls_last',
          id: 'desc'
        }
      }
      var data = await DataServices.getList('categories', {"variables": JSON.stringify(variables), "fields": "id,name"});
      this.optionsCategories.push({label: "Tất cả", value: 0});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          this.optionsCategories.push({label: item.name, value: item.id});
          this.importCategories.push({name: item.name, id: item.id});
        }
      }
    },
    onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          if (this.checkVisible('product', 'add')) {
            this.$router.push({path: '/admin/product/function'});
          } else {
            this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Bạn không có quyền truy cập', life: 3000 })
          }
          break;
        case 'edit':
          if (this.checkVisible('product', 'edit')) {
            if (data && Object.keys(data).length) {
              this.$router.push({path: '/admin/product/function/' + data.data.id});
            }
          } else {
            this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Bạn không có quyền truy cập', life: 3000 })
          }
          break;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        if (that.checkVisible('product', 'edit')) {
          buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `admin/product-${this.modelName}/edit`}
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
      // this.componentKey++;
      this.listDataExport = this.listData;
    },
    
    async addHistoryModelProductImport() {
      if (this.exportData != null && this.exportData.length &&  this.$store.getters != null &&  this.$store.getters.fullname != null) {
        var organizationID = (this.$store.getters.fullname.organization_account != null && this.$store.getters.fullname.organization_account != null) ? this.$store.getters.fullname.organization_account.organization_id : 0; 
        var userID = this.$store.getters.fullname.id;
        var params = [];
        for (let index = 0; index < this.exportData.length; index++) {
          const item = this.exportData[index];
          var dataProduct = await DataServices.getList('product', {"variables": JSON.stringify({where_key: { model_code: {'_eq': item.code}}}), "fields": "id description created_date category_id is_manually_verification is_returnable last_modifier model_code modified_date name production_status qr_code_size returnable_time returnable_unit slug status warranty_unit warranty_time thumbnail_id thumbnails { external_path cdn_path local_path  }"});
          var listProduct = dataProduct[Object.keys(dataProduct)];
          if (listProduct !== undefined && listProduct !== null && Object.keys(listProduct).length) {
            var oldProduct = listProduct[0];
            var newProduct = oldProduct;
            newProduct['name'] = item.name;
            newProduct['category_id'] = item.cate_id;
            newProduct['warranty_time'] = item.warranty;
            newProduct['returnable_time'] = item.returnable;
            newProduct['qr_code_size'] = item.qr_size;
            newProduct['production_status'] = item.status_id;
            newProduct['thumbnail_url'] = (item.thumbnails != undefined && item.thumbnails != null) ?  ((item.thumbnails.external_path != '') ? item.thumbnails.external_path : ((item.thumbnails.local_path != '') ? item.thumbnails.cdn_path + ''+ item.thumbnails.local_path : '')) : '';
            params.push({product_id: oldProduct.id, modifier_id: userID, organization_id: organizationID, modified_date: this.$myConstants.currentDate(), created_date: this.$myConstants.currentDate(), status: 1, old_value: oldProduct, new_value: newProduct});
          }
        }
        if (params.length > 0) {
          await DataServices.insertData('product_changed_log', {"variables": JSON.stringify({objects: params})});
          return true;
        }
      }
      return false;
    },

    async checkImportProcessing() {
      var variables = {
        where_key: {
          id: {'_eq': this.importID},
          import_type: {'_eq': 'product'}
        }
      }
      var data = await DataServices.getList('import_data_processing', {"variables": JSON.stringify(variables), "fields": "data data_errors message count_data_processing process_status status"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        var result = list[0];
        this.messages = result.message;
        this.exportData = result.data;
        // lỗi import
        if (result.process_status == 4) {
          this.displayDialog = true;
          this.importComponentKey = Math.random()*2000;
          return true;
        } else if (result.process_status == 3) {
          this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Import thành công', life: 3000 })
          var checkHistory = this.addHistoryModelProductImport();
          if (checkHistory) {
            this.$store.commit('setLoading', false);
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
          return true;
        } else if (result.status == 4 || result.status == 3) {
          this.displayDialog = true;
          this.importComponentKey = Math.random()*300;
          return true;
        }
        return false;
      }
      return true;
    },
    waittingImport() {
      var step = 0;
      var vm = this;
      if (this.importID > 0) {
        var callData  =  window.setInterval(async () => {
          step++;
          if (step > vm.seconds) {
            step = 0;
            var stop = await vm.checkImportProcessing();
            if (stop) {
              vm.$store.commit('setLoading', false);
              clearInterval(callData);
            }
          }
        }, 1000);
      }
    },
    async addRecords(response) {
      var params = {};
      var vm = this;
      var fileName = response.data.path;
      fileName = (fileName.substring(0, 1) == '/' ? fileName.substring(1) : fileName);
      params = Object.assign(params, { 'user_id': this.$store.getters.fullname.id })
      params = Object.assign(params, { 'file_path': fileName })
      params = Object.assign(params, { 'import_type': 'product' })
      params = Object.assign(params, { 'process_status': 1 })
      params = Object.assign(params, { 'status': 1 })
      params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() });
      params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() });
      var result = await DataServices.insertData('import_data_processing', {"variables": JSON.stringify({objects: params})});
      if (result != null) {
        var checkInsert = result[Object.keys(result)];
        if (checkInsert.affected_rows && this.seconds > 0) {
          var importID = checkInsert.returning[0].id;
          vm.importID = importID;
          await vm.waittingImport();
        } else this.$store.commit('setLoading', false);
      } else this.$store.commit('setLoading', false);
    },
    removeFile() {
      this.files = [];
      document.getElementById("files").value = null;
      this.filename = 'Không có file đang chọn';
    },
    openFile() {
      this.$refs.files.click();
    },
    chooseFile($event) {
      $event.preventDefault();
      var fileSelects = $event.target.files || $event.dataTransfer.files;
      if (!fileSelects.length)
        return;
      var file = fileSelects[0].name;
      var extension = this.$myConstants.getFileExtension(file);
      this.files = [];
      if (['xlsx', 'xls'].includes(extension)) {
        this.files.push(fileSelects);
        this.filename = file;
      } else {
        this.files = [];
        this.filename = 'Không có file đang chọn';
        this.errorsText = 'Import thất bại do sai template';
        document.getElementById("files").value = null;
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: this.errorsText, life: 3000 })
      }
    },
    async importData() {
      if (this.files.length > 0) {
        this.$store.commit('setDataLoading', {content: 'Đang kiểm tra file import', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        var file = this.$refs.files.files[0];
        var reader = new FileReader();
        reader.onload = function(e) {
          var data = e.target.result, 
          fixedData = vm.fixedData(data), 
          workbook = XLSX.read(btoa(fixedData), {type: 'base64'}), 
          firstSheetName = workbook.SheetNames[0],
          worksheet = workbook.Sheets[firstSheetName];
          vm.fileInputData = worksheet;
          if (firstSheetName != 'Danh_sach_import') {
            vm.$store.commit('setLoading', false);
            vm.files = [];
            vm.filename = 'Không có file đang chọn';
            document.getElementById("files").value = null;
            vm.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Import thất bại do sai template', life: 3000 })
          } else {
            vm.processImport(file, vm.fileInputData);
          }
        };
        reader.readAsArrayBuffer(file);
      }
    },
    getHeaderRow(sheet) {
      var headers = [], range = XLSX.utils.decode_range(sheet['!ref']);
      var C, R = range.s.r; /* start in the first row */
      for(C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
          var cell = sheet[XLSX.utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
          if (cell !== undefined) {
            var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
            if(cell && cell.t) hdr = XLSX.utils.format_cell(cell);
            headers.push(hdr);
          }
      }
      return headers;
    },
    fixedData(data) {
      var o = "", l = 0, w = 10240;
      for(; l<data.byteLength/w; ++l) o+=String.fromCharCode.apply(null,new Uint8Array(data.slice(l*w,l*w+w)));
      o+=String.fromCharCode.apply(null, new Uint8Array(data.slice(l*w)));
      return o;
    },
    async checkWorkSheetToJson(file, worksheet) {
      var vm = this;
      vm.parse_header = vm.getHeaderRow(worksheet);
      var headerText = vm.parse_header.join(',').toLowerCase().replace(/\s/g, '').trim();
      var parseHeader = vm.parse_key.join(',').toLowerCase().replace(/\s/g, '').trim();
      if (vm.parse_key.length < vm.parse_header.length || vm.parse_key.length > vm.parse_header.length || parseHeader != headerText) {
        this.$store.commit('setLoading', false);
        this.errorsText = 'Import thất bại do sai template';
        this.files = [];
        this.filename = 'Không có file đang chọn';
        document.getElementById("files").value = null;
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: this.errorsText, life: 3000 })
      }
      else  {
        var results = XLSX.utils.sheet_to_json(worksheet);
        if (results != null && results.length != undefined && results.length > 5001) {
          this.$store.commit('setLoading', false);
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Dữ liệu đã vượt quá 5000 dòng, vui lòng kiểm tra lại file import', life: 3000 })
        } else {
          let formData = new FormData();
          formData.append('file', file)
          await Api.post('/common/upload-s3', formData)
          .then(async (response) => {
            await vm.addRecords(response.data);
          })
          .catch(async (error) => {
            this.$store.commit('setLoading', false);
            vm.$toast.add({ severity: 'error', summary: 'Thông báo', detail: error, life: 3000 })
          });
        }
      }
    },
    async processImport(file, worksheet) {
      await this.checkWorkSheetToJson(file, worksheet);
    },
    async exportDataExcelFile() {
      if (this.data_filter_export.is_data == 0){
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Không tồn tại dữ liệu xuất',
          life: 3000
        });
        return false;
      }
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
        try {
          var dataResponse = await this.$coreService.callApiPost('/export_excel/list_product',{data_filter_export:this.data_filter_export,user_id : this.userID},{})
          var key_s3 = dataResponse.data.data.key_s3;
          var dataResponseDownload = await this.$coreService.callApiDownloadPost('/export_excel/read_file_export',{key_s3:key_s3},{})
          var url = URL.createObjectURL(new Blob([dataResponseDownload.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url;
          var file_excel = 'BC_DanhSachModel_'+moment().tz("Asia/Bangkok").format('DDMMYYYY')+'_'+moment().tz("Asia/Bangkok").format('HHmmss')+'.xlsx';
          link.setAttribute('download', file_excel)
          document.body.appendChild(link)
          link.click()
          this.showConfirmDialog = true;
          this.creenConfirmDialog = 'export_success';

      } catch (err) {
          console.log("err:",err);
          this.showConfirmDialog = true;
          this.creenConfirmDialog = 'export_err';
        }
      this.$store.commit('setLoading', false);
    },
    dang_phat_trien(){
      alert('Đang phát triển');
    },
    redirect_ToHistory(){
      this.$router.push({path: '/admin/history-export'});
    },
    async filterData(payload){
      this.listDataExport = payload.filteredValue;
    },
    exportDataExcel() {
      if (this.exportData.length > 0) {
        this.$store.commit('setDataLoading', {content: 'Đang tải file', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        setTimeout(() => {
          vm.exportExcel();
        }, 2000);
      }
    },
    exportExcel() {
      var dataJson = [];
      for (let index = 0; index < this.exportData.length; index++) {
        var item = this.exportData[index];
        dataJson.push({
          'STT': (index + 1),
          'Model sản phẩm*': (item['code'] != undefined && item['code'] != null) ? item['code']: '',
          'Tên sản phẩm*': (item['name'] != undefined && item['name'] != null) ? item['name']: '',
          'Nhóm sản phẩm*': (item['cate_name'] != undefined && item['cate_name'] != null) ? item['cate_name']: '',
          'Thời hạn bảo hành (tháng)*': (item['raw_warranty'] != undefined && item['raw_warranty'] != null) ? item['raw_warranty']: '',
          'Thời hạn đổi (ngày)': (item['raw_change_time'] != undefined && item['raw_change_time'] != null) ? item['raw_change_time']: '',
          'Thời hạn trả_tự duyệt (ngày)': (item['raw_returnable'] != undefined && item['raw_returnable'] != null) ? item['raw_returnable']: '',
          'Thời hạn trả_thẩm định (ngày)': (item['raw_returnable_appraisal'] != undefined && item['raw_returnable_appraisal'] != null) ? item['raw_returnable_appraisal']: '',
          'Mẫu QR Code*': (item['qr_size'] != undefined && item['qr_size'] != null) ? item['qr_size']: '',
          'Trạng thái sản xuất*': (item['status'] != undefined && item['status'] != null) ? item['status']: '',
          'Hình ảnh': (item['image'] != undefined && item['image'] != null) ? item['image']: '',
          'note': (item['message'] != undefined && item['message'] != null) ? item['message']: '',
        });
      }
      if (dataJson !== null) {
        var d = new Date();
        var fileName = 'DanhSachModelSP_'  + moment(d).format('DDMMYYYY') + '_' + moment(d).format('HHmmss') + '.xlsx';
        var dataSheet = XLSX.utils.json_to_sheet(dataJson) 
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataSheet)
        XLSX.writeFile(wb, fileName);
        this.$store.commit('setLoading', false);
      }
    },
    pageClick(payload) {
      if (payload) {
        this.currentPage = payload.page;
        this.first = payload.first;
        localStorage.setItem('currentPage', this.currentPage);
        this.initParams();
      }
    },
    chang_date_number(){
      this.disable_update_date_number = false;
    },
    update_date_number(){
      if (this.$myConstants.isEmpty(this.disable_update_date_number)){
        this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Vui lòng nhập số ngày gia hạn thời gian bảo hành tối đa', life: 3000 });
        return false;
      }
      var whereObjectSetting = {
        key: {'_eq': this.$dataCommon.SETTING.MAXIMUM_WARRANTY_EXTENSION_TIME}
      }
      var maximum_warranty_extension_time = this.maximum_warranty_extension_time.toString()
      DataServices.updateData('settings', {"variables": JSON.stringify({data_update: {value:  maximum_warranty_extension_time}, where_key: whereObjectSetting})}).then(async () => {
        this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 });
        this.disable_update_date_number = true;
      }).catch(async () => {
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
          life: 3000
        });
      });
    },
    async filterExport(e){
       //console.log("EEE",e)
      this.data_filter_export = e
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
.box_config_model{
  margin: 0px;
  .box_import_data{
    width: calc(50% - 8px);
    margin-right: 8px;
  }
  .box_config_time{
    width: calc(50% - 8px);
    margin-left: 8px;
    .group_input_date{
      width: 180px;
      .input_date_number{
        width: 110px;
        .p-inputnumber-input{
          width: 110px;
          height: 35px;
        }
      }
    }
    .note_date_nunber{
      font-family: 'Arial Bold Italic', 'Arial'; font-weight: 700; font-style: italic; text-decoration: underline;
    }
  }
}
.list_warranty_repair{
  .late_delivery_return_appointment_day{
    color: #CC0000;
  }
}



.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}

</style>